import { ShieldCheck, LockKeyhole, Star } from "lucide-react";

export default function OgCard() {
  return (
    <div
      data-testid="og-card"
      style={{ width: 1200, height: 630 }}
      className="bg-navy relative overflow-hidden flex flex-col justify-between p-14"
    >
      <div className="absolute -right-32 -top-32 w-[440px] h-[440px] rounded-full bg-teal/20 blur-3xl" />
      <div className="absolute -left-24 -bottom-24 w-[360px] h-[360px] rounded-full bg-teal/10 blur-3xl" />

      <div className="relative">
        <img src="/brand/logo-full-white.png" alt="Your Helper" className="h-12 w-auto" />
      </div>

      <div className="relative">
        <p className="font-mono text-sm uppercase tracking-[0.3em] text-teal-light">
          The UK's local services marketplace
        </p>
        <h1 className="mt-5 font-display font-extrabold tracking-[-0.03em] text-white text-[64px] leading-[1.05]">
          Get things done by
          <br />
          <span className="text-teal-light">trusted people</span> near you.
        </h1>
        <p className="mt-5 text-slate-300 text-2xl">Post a job. Compare offers. Pay securely.</p>
      </div>

      <div className="flex items-center gap-8 relative">
        <span className="inline-flex items-center gap-2 text-slate-300 text-lg">
          <ShieldCheck className="w-5 h-5 text-teal-light" /> Verified people
        </span>
        <span className="inline-flex items-center gap-2 text-slate-300 text-lg">
          <LockKeyhole className="w-5 h-5 text-teal-light" /> Secure payments
        </span>
        <span className="inline-flex items-center gap-2 text-slate-300 text-lg">
          <Star className="w-5 h-5 text-teal-light" /> Reviews you can trust
        </span>
      </div>
    </div>
  );
}
